import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { MatterSummary } from '@/services/api/notificationsService';

interface NotificationDetailHeaderProps {
  matter?: MatterSummary | null;
}

export const NotificationDetailHeader: React.FC<NotificationDetailHeaderProps> = ({
  matter,
}) => {
  return (
    <div className="flex items-center justify-between px-4 py-2.5 border-b border-gray-200 bg-white">
      {/* Matter info */}
      <div>
        <h2 className="text-sm font-bold text-gray-900">
          {matter?.name || 'Unknown Matter'}
        </h2>
        {matter?.firm_name && (
          <p className="text-xs text-gray-500 font-medium">
            {matter.firm_name}
          </p>
        )}
      </div>

      {/* View matter button */}
      {matter && (
        <Link
          to={`/matters/${matter.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 px-2.5 py-1 text-xs font-semibold text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
        >
          <ExternalLink className="w-3.5 h-3.5" />
          View matter
        </Link>
      )}
    </div>
  );
};
